import { useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";

export const ComparisonTable: React.FC<{
  leftTitle: string;
  rightTitle: string;
  rows: Array<{
    feature: string;
    left: string;
    right: string;
    leftColor?: string;
    rightColor?: string;
  }>;
  delay?: number;
  leftAccent?: string;
  rightAccent?: string;
}> = ({
  leftTitle,
  rightTitle,
  rows,
  delay = 0,
  leftAccent = "#EF4444",
  rightAccent = "#34D399",
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const headerProgress = spring({
    frame: frame - delay,
    fps,
    config: { damping: 12, stiffness: 100 },
  });

  const headerOpacity = interpolate(headerProgress, [0, 1], [0, 1]);

  const cellStyle: React.CSSProperties = {
    padding: "12px 16px",
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 15,
    borderBottom: "1px solid #1E293B",
  };

  return (
    <div
      style={{
        width: 900,
        borderRadius: 16,
        overflow: "hidden",
        background: "#111827",
        border: "1px solid #1E293B",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          opacity: headerOpacity,
          borderBottom: "2px solid #1E293B",
        }}
      >
        <div
          style={{
            ...cellStyle,
            flex: 2,
            fontWeight: 600,
            color: "#94A3B8",
            fontSize: 13,
            textTransform: "uppercase" as const,
            letterSpacing: 1,
          }}
        >
          Feature
        </div>
        <div
          style={{
            ...cellStyle,
            flex: 1,
            fontWeight: 600,
            color: leftAccent,
            fontSize: 13,
            textTransform: "uppercase" as const,
            letterSpacing: 1,
            textAlign: "center",
          }}
        >
          {leftTitle}
        </div>
        <div
          style={{
            ...cellStyle,
            flex: 1,
            fontWeight: 600,
            color: rightAccent,
            fontSize: 13,
            textTransform: "uppercase" as const,
            letterSpacing: 1,
            textAlign: "center",
          }}
        >
          {rightTitle}
        </div>
      </div>

      {/* Rows */}
      {rows.map((row, i) => {
        const rowDelay = delay + 10 + i * 8;
        const rowProgress = spring({
          frame: frame - rowDelay,
          fps,
          config: { damping: 14, stiffness: 120 },
        });

        const rowOpacity = interpolate(rowProgress, [0, 1], [0, 1]);
        const translateX = interpolate(rowProgress, [0, 1], [-40, 0]);

        return (
          <div
            key={i}
            style={{
              display: "flex",
              opacity: rowOpacity,
              transform: `translateX(${translateX}px)`,
            }}
          >
            <div
              style={{
                ...cellStyle,
                flex: 2,
                color: "#E2E8F0",
                fontWeight: 500,
              }}
            >
              {row.feature}
            </div>
            <div
              style={{
                ...cellStyle,
                flex: 1,
                color: row.leftColor ?? leftAccent,
                textAlign: "center",
              }}
            >
              {row.left}
            </div>
            <div
              style={{
                ...cellStyle,
                flex: 1,
                color: row.rightColor ?? rightAccent,
                textAlign: "center",
              }}
            >
              {row.right}
            </div>
          </div>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
